import React, { useContext } from "react";
import App from "../App";
import paths, { rootPaths } from "./paths";
import { Navigate, createBrowserRouter, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

// Componentes provisionales
import MainLayout from "../layouts/MainLayout";
import SplitLogin from "../components/authentication/split/Login";
import ErrorPage from "../components/errors/ErrorPage";
import ErrorBoundary from "../components/errors/ErrorBoundary";
import FontAwesome from "../components/doc-components/FontAwesome";
import ReactIcons from "../components/doc-components/ReactIcons";
import AlertaReport from "../pages/reportes/reporte_alertas/index";
import UsabilityReport from '../pages/reportes/reporte_usabilidad/index';
import RecorridosReport from "../pages/reportes/reporte_recorridos";
import EstadiasReport from "../pages/reportes/reporte_estadias";
import PuntoCercanoReport from "../pages/reportes/reporte_puntocercano";
import IndexReportKM from "../pages/reportes/reporte_km";
import ParadasNoAutorizadas from "../pages/reportes/reporte_paradas_no_autorizadas";
import BitacoraReport from "../pages/reportes/reporte_bitacoras";
import ConsumoReport from "../pages/reportes/reporte_consumo";
import ApagadosEncendidosReport from "../pages/reportes/reporte_apagados_encendidos";
import ReporteHorarioNoLaboral from "../pages/reportes/reporte_horario_no_laboral";
import TemperaturaReport from "../pages/reportes/reporte_temperatura";

// Importar estilos del Dashboard
import "../components/dashboard/Dashboard.css";

const Dash = () => (
  <div className="dashboard-container">
    <div className="hero-section">
      <div className="watermark"></div>
      <h1 className="main-title">Reportería</h1>
      <p className="subtitle">Sistema de reportes y análisis</p>
    </div>
  </div>
);
const ReportsLayout = () => (
  <div>
    <h1>Reportes</h1>
  </div>
);
const LogisticaReport = () => (
  <div>
    <h2> Logística</h2>
  </div>
);

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ProtectedRoute = ({ children }) => {

  const navigate = useNavigate();
  const { login, setAutenticado } = useContext(AuthContext);
  const query = useQuery();

  const _token = query.get('token')
  const _modulo = query.get('modulo')
  const _vista = query.get('vista')

  if (_token != undefined) {
    localStorage.setItem("auth", "true")
    localStorage.setItem("token", _token)
    setAutenticado(true)
    navigate(`/${_modulo}?vista=${_vista}`)
  }

  const token = localStorage.getItem("token");

  // Si no hay token pero auth quedó en "true", limpiar estado inconsistente
  if (!token && localStorage.getItem("auth") === "true") {
    localStorage.removeItem("auth");
    localStorage.removeItem("empresa_id");
    localStorage.removeItem("uid_empresa");
  }

  return token ? children : <Navigate to={paths.splitLogin} replace />;
};

// Configuración de rutas
const routes = [
  {
    element: (
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        path: "landing",
        element: <ReportsLayout />,
      },
      {
        path: "/",
        element: (
          <ProtectedRoute>
            <MainLayout />,
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: <Dash />, // Página bienvenida
          },
          {
            path: "recorridos",
            element: <RecorridosReport />, // Página de recorridos
          },
          {
            path: "logistica",
            element: <LogisticaReport />, // Página de logística
          },
          {
            path: "reporte_alertas",
            element: <AlertaReport />, // reporte alerta
          },
          {
            path: 'reporte_usabilidad',
            element: <UsabilityReport /> // reporte usabilidad
          },
          {
            path: "reporte_recorridos",
            element: <RecorridosReport />,
          },
          {
            path: "reporte_estadias",
            element: <EstadiasReport />,
          },
          {
            path: "reporte_km",
            element: <IndexReportKM />,
          },
          {
            path: "reporte_paradas_no_autorizadas",
            element: <ParadasNoAutorizadas />,
          },
          {
            path: "reporte_puntocercano",
            element: <PuntoCercanoReport />,
          },
          {
            path: "reporte_bitacora",
            element: <BitacoraReport />,
          },
          {
            path: "reporte_consumo",
            element: <ConsumoReport />,
          },
          {
            path: "reporte_apagados_encendidos",
            element: <ApagadosEncendidosReport />,
          },
          {
            path: "reporte_horario_no_laboral",
            element: <ReporteHorarioNoLaboral />,
          },
          {
            path: "reporte_temperatura",
            element: <TemperaturaReport />
          },
        ],
      },
      {
        path: rootPaths.authRoot,
        children: [
          {
            path: rootPaths.authSplitRoot,
            children: [
              {
                path: paths.splitLogin,
                element: <SplitLogin />,
              },
            ],
          },
        ],
      },
      {
        path: rootPaths.iconsRoot,
        children: [
          {
            path: paths.fontAwesome,
            element: <FontAwesome />,
          },
          {
            path: paths.reactIcons,
            element: <ReactIcons />,
          },
        ],
      },

      {
        path: "*",
        element: <ErrorPage errorCode={404} />,
      },
    ],
  },
];

export const router = createBrowserRouter(routes, {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true,
  },
});

export default routes;
